<template>
  <ul class="menu-nav">

    <!-- Separador o título para la sección de Dashboard -->
    <router-link to="/dashboard-all" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-layers"></i>
          <span class="menu-text">Dashboard total</span>
        </a>
      </li>
    </router-link>

    <!-- Normal links -->
    <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">Dashboard medical appointments</span>
        </a>
      </li>
    </router-link>

    <!-- Aquí irían los demás links normales -->
    <Admin></Admin>
    <Appointment></Appointment>
    <Patient></Patient>
    <OfficeVisit></OfficeVisit>
    <AdminData></AdminData>
    <CashAccount></CashAccount>

    <!-- Separador o título para la sección de Insurance -->
    <li class="menu-section">
      <h4 class="menu-text">Insurance</h4>
    </li>

    <!-- Insurance links -->

    <!-- Normal links -->
    <router-link
      to="/dashboard-insurance"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">Dashboard insurance</span>
        </a>
      </li>
    </router-link>

    <InsuranceAdmin></InsuranceAdmin>
    <InsuranceAppointment></InsuranceAppointment>
    <InsurancePatient></InsurancePatient>
    <InsuranceOfficeVisit></InsuranceOfficeVisit>
    <InsuranceCashAccount></InsuranceCashAccount>
  </ul>
</template>

<script>
import Admin from './components/Admin.vue'
import InsuranceAdmin from './components/InsuranceAdmin.vue'
import AdminData from './components/AdminData.vue'
import Appointment from './components/Appointment.vue'
import InsuranceAppointment from './components/InsuranceAppointment.vue'
import Patient from './components/Patient.vue'
import InsurancePatient from './components/InsurancePatient.vue'
import OfficeVisit from './components/OfficeVisit.vue'
import InsuranceOfficeVisit from './components/InsuranceOfficeVisit.vue'
import CashAccount from './components/CashAccount.vue'
import InsuranceCashAccount from './components/InsuranceCashAccount.vue'
export default {
  name: 'KTMenu',
  components: {
    Admin,
    InsuranceAdmin,
    InsuranceAppointment,
    Patient,
    Appointment,
    OfficeVisit,
    CashAccount,
    AdminData,
    InsurancePatient,
    InsuranceOfficeVisit,
    InsuranceCashAccount,
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1
    },
  },
}
</script>
